/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 10:45:59
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-22 17:00:51
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PackingSlip/PackingSlipSize/index.tsx
 */
import { Form } from 'antd';
import React from 'react';

import { Radio } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from '../css.module.less';

const PackingSlipSize = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.container}
      title={getI18n('storeLogistics.packingSlip.packingSlipSize')}>
      <Form.Item noStyle name='slipSize'>
        <Radio
          className={css.radioContain}
          radioList={[
            {
              label: `A4 ${replaceI18nVariables(
                getI18n('general.upload.EditModal.size'),
                '(210 x 297mm)',
              )}`,
              value: 'A4',
            },
            {
              label: `A5 ${replaceI18nVariables(
                getI18n('general.upload.EditModal.size'),
                '(148 x 210mm)',
              )}`,
              value: 'A5',
            },
          ]}></Radio>
      </Form.Item>
    </SectionWrapper>
  );
};
export default PackingSlipSize;
